import { Redirect, Route } from 'react-router-dom';
import React from 'react';

import Auth from 'utils/auth';

// Component

const PrivateRoute = ({ component: Component, permission: role, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props =>
        Auth.isLoggedIn() && Auth.isPermissioned(role) ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: role ? '/' : '/sign-in',
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/utils/privateRoute.js